// Uncomment the URL you want to use for the API

// -- LIVE URL --
export const API_URL = "https://sf.doaguru.com";

// -- LOCAL URL --
// export const API_URL = "http://localhost:8080";
